'use strict';

var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
require('core-js/modules/es.array.iterator.js');
require('core-js/modules/web.dom-collections.iterator.js');
var react = require('react');
require('prop-types');
var frontendImage = require('frontend-image');
var card = require('@polycard/card');
require('core-js/modules/es.error.cause.js');
require('core-js/modules/es.promise.js');
require('core-js/modules/es.regexp.exec.js');
require('core-js/modules/es.string.trim.js');
var frontendRestclient = require('frontend-restclient');
require('core-js/modules/es.array.includes.js');
var jsxRuntime = require('react/jsx-runtime');
var isEmpty = require('lodash/isEmpty');
var isObject = require('lodash/isObject');
var MoneyAmount = require('@andes/money-amount');
require('core-js/modules/es.array.reduce.js');
var classnames = require('classnames');
var button = require('@andes/button');
require('core-js/modules/es.string.replace.js');
const useIntersectionObserver = function () {
  let {
    externalRef = null,
    rootMargin = '0px',
    threshold = 0.1,
    once = false,
    startOff = false,
    fallbackValue = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // IS ON THE VIEWPORT => current visibility status of the element
  const [isOnViewport, setIsOnViewport] = react.useState(false);

  // INTERNAL REF => makes available a reference (used only if none come from outside)
  const fromRef = react.useRef();

  // OBSERVER => makes the observer available from outside
  const observerRef = react.useRef(null);

  // INIT observer function => makes a new instance of intersection observer
  const initObserverFnRef = react.useRef((callback, config) => {
    const observerInstance = new IntersectionObserver(callback, config);
    return observerInstance;
  });
  const initObserver = initObserverFnRef.current;

  // DISCONNECT observer function => shuts down the observer (to clean effects or unmount components)
  const disconnectObserverFnRef = react.useRef(_ref => {
    let {
      observer = observerRef.current
    } = _ref;
    if (observer) observer.disconnect();
  });
  const disconnectObserver = disconnectObserverFnRef.current;

  // OBSERVE element function => start observing an element
  const observeElementFnRef = react.useRef(_ref2 => {
    let {
      observer = observerRef.current,
      element
    } = _ref2;
    if (observer && element) {
      observer.observe(element);
    }
  });
  const observeElement = observeElementFnRef.current;

  // UNOBSERVE element function => stop observing an element
  const unobserveElementFnRef = react.useRef(_ref3 => {
    let {
      observer = observerRef.current,
      element
    } = _ref3;
    if (observer && element) observer.unobserve(element);
  });
  const unobserveElement = unobserveElementFnRef.current;
  react.useEffect(() => {
    const elementRef = externalRef ? externalRef.current : fromRef.current;
    if (global.IntersectionObserver) {
      const onChange = (entries, io) => {
        if (entries[0].isIntersecting) {
          setIsOnViewport(true);
          if (once) unobserveElement({
            observer: io,
            element: elementRef
          });
        } else {
          setIsOnViewport(false);
        }
      };
      observerRef.current = initObserver(onChange, {
        rootMargin,
        threshold
      });
      if (!startOff) observeElement({
        observer: observerRef.current,
        element: elementRef
      });
    } else {
      setIsOnViewport(fallbackValue);
    }
    return () => {
      disconnectObserver({
        observer: observerRef.current
      });
    };
  }, [rootMargin, threshold, externalRef, once, startOff, initObserver, observeElement, unobserveElement, disconnectObserver, fallbackValue]);
  return {
    isOnViewport,
    setIsOnViewport,
    fromRef,
    observer: observerRef.current,
    initObserver,
    disconnectObserver,
    observeElement,
    unobserveElement
  };
};
var useIntersectionObserver$1 = useIntersectionObserver;
var canUseWebp = new Promise(resolve => {
  resolve(true);
});
const sites = {
  MLA: {
    url: {
      mainDomain: 'mercadolibre.com.ar',
      baseDomain: '//www.mercadolibre.com.ar'
    }
  },
  MPE: {
    url: {
      mainDomain: 'mercadolibre.com.pe',
      baseDomain: '//www.mercadolibre.com.pe'
    }
  },
  MPT: {
    url: {
      mainDomain: 'mercadolivre.pt',
      baseDomain: '//www.mercadolivre.pt'
    }
  },
  MRD: {
    url: {
      mainDomain: 'mercadolibre.com.do',
      baseDomain: '//www.mercadolibre.com.do'
    }
  },
  MPA: {
    url: {
      mainDomain: 'mercadolibre.com.pa',
      baseDomain: '//www.mercadolibre.com.pa'
    }
  },
  MEC: {
    url: {
      mainDomain: 'mercadolibre.com.ec',
      baseDomain: '//www.mercadolibre.com.ec'
    }
  },
  MCR: {
    url: {
      mainDomain: 'mercadolibre.co.cr',
      baseDomain: '//www.mercadolibre.co.cr'
    }
  },
  MLU: {
    url: {
      mainDomain: 'mercadolibre.com.uy',
      baseDomain: '//www.mercadolibre.com.uy'
    }
  },
  MLM: {
    url: {
      mainDomain: 'mercadolibre.com.mx',
      baseDomain: '//www.mercadolibre.com.mx'
    }
  },
  MLC: {
    url: {
      mainDomain: 'mercadolibre.cl',
      baseDomain: '//www.mercadolibre.cl'
    }
  },
  MCO: {
    url: {
      mainDomain: 'mercadolibre.com.co',
      baseDomain: '//www.mercadolibre.com.co'
    }
  },
  MLV: {
    url: {
      mainDomain: 'mercadolibre.com.ve',
      baseDomain: '//www.mercadolibre.com.ve'
    }
  },
  MLB: {
    url: {
      mainDomain: 'mercadolivre.com.br',
      baseDomain: '//www.mercadolivre.com.br'
    }
  },
  MBO: {
    url: {
      mainDomain: 'mercadolibre.com.bo',
      baseDomain: '//www.mercadolibre.com.bo'
    }
  },
  MPY: {
    url: {
      mainDomain: 'mercadolibre.com.py',
      baseDomain: '//www.mercadolibre.com.py'
    }
  },
  MGT: {
    url: {
      mainDomain: 'mercadolibre.com.gt',
      baseDomain: '//www.mercadolibre.com.gt'
    }
  },
  MHN: {
    url: {
      mainDomain: 'mercadolibre.com.hn',
      baseDomain: '//www.mercadolibre.com.hn'
    }
  },
  MNI: {
    url: {
      mainDomain: 'mercadolibre.com.ni',
      baseDomain: '//www.mercadolibre.com.ni'
    }
  },
  MSV: {
    url: {
      mainDomain: 'mercadolibre.com.sv',
      baseDomain: '//www.mercadolibre.com.sv'
    }
  },
  MCU: {
    url: {
      mainDomain: 'mercadolibre.com.cu',
      baseDomain: '//www.mercadolibre.com.cu'
    }
  }
};
var config = sites;
const mapPropsToQuery = _ref => {
  let {
    componentProps,
    paramsToMap
  } = _ref;
  const query = {};
  paramsToMap.forEach(param => {
    if (param in componentProps) {
      // eslint-disable-next-line security/detect-object-injection
      query[param] = componentProps[param];
    }
  });
  return query;
};
var mapPropsToQuery$1 = mapPropsToQuery;
const divideByGroups = (arr, groupsOf) => {
  const groups = [];
  for (let i = 0, n = arr.length / groupsOf; i < n; i += 1) {
    const slice = arr.slice(groupsOf * i, groupsOf * (i + 1));
    groups.push({
      elements: slice,
      id: slice.map(c => c.id).join('-')
    });
  }
  return groups;
};
var divideByGroups$1 = divideByGroups;
const API_PATH = '/recommendations';
const API_PATH_POLYCARD = '/recommendations/v2';
const FALLBACK_URL = 'https://www.mercadolibre.com.ar';
const restClientConfig = {
  timeout: 30000,
  baseURL: FALLBACK_URL,
  withCredentials: true,
  sendCSRFToken: false
};
const restclient$1 = frontendRestclient(restClientConfig);
const defaultHeaders = {
  'x-card-type': 'web',
  'x-recosplugin-version': '###VERSION###'
};
const polycardHeaders = {
  'x-card-type': 'polycard'
};
const requiredParams = ['site_id', 'client'];
const forwardedPropsToItem = ['lazyLoad', 'addToCartPublicEndpoint', 'csrfToken'];
const buildErrorTrack = client => ({
  event_data: {
    recommendations: {
      client,
      has_errors: true,
      track_info: {}
    }
  }
});
const getHostname = params => {
  if (params.site_platform === 'MS' || params.site_platform === 'PI') {
    return "https://".concat(params.host_rewrite);
  }
  if (config[params.site_id] == null) {
    return FALLBACK_URL;
  }
  return "https:".concat(config[params.site_id].url.baseDomain);
};
const validateParams = params => {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < requiredParams.length; i++) {
    // eslint-disable-next-line security/detect-object-injection
    if (!params[requiredParams[i]] || params[requiredParams[i]] === undefined || params[requiredParams[i]] === null) {
      return false;
    }
  }
  return true;
};
const formatApiResponse = (data, props, carouselKey) => {
  var _data$recommendation_, _data$recommendation_2, _data$recommendation_3, _data$recommendation_4;
  const title = props.title || data.title || '';
  const titleWithIcons = props.titleWithIcons || data.title_with_icons;
  const titleTag = props.titleTag || data.title_tag;
  const subtitle = props.subtitle || data.subtitle;
  const footer = props.footer || data.footer;
  const href = props.href || data.href;
  const prevItemsFromProps = props.prevItems || [];
  const itemsFromRecos = ((_data$recommendation_ = data.recommendation_info) === null || _data$recommendation_ === void 0 ? void 0 : _data$recommendation_.recommendations) || ((_data$recommendation_2 = data.recommendation_info) === null || _data$recommendation_2 === void 0 ? void 0 : _data$recommendation_2.polycards) || [];
  const polycardContext = ((_data$recommendation_3 = data.recommendation_info) === null || _data$recommendation_3 === void 0 ? void 0 : _data$recommendation_3.polycard_context) || {};
  const multipleRows = props.multipleRows || false;
  const classnameFromResponse = data.class_name;
  const itemImagesToPreload = props.itemImagesToPreload || data.itemImagesToPreload;
  const fetchPriority = props.fetchPriority || data.fetchPriority || 'auto';
  const track = data.tracking || buildErrorTrack(props.client);
  if (data.advertising_info) {
    track.advertising_info = data.advertising_info;
  }
  const message = data.message || false;
  const viewMoreAction = props.viewMoreAction || data.view_more_action || undefined;
  const carouselType = props.carouselType || ((_data$recommendation_4 = data.recommendation_info) === null || _data$recommendation_4 === void 0 ? void 0 : _data$recommendation_4.carousel_type);
  if (itemsFromRecos.length < 1 && props.onCarouselIsEmpty && typeof props.onCarouselIsEmpty === 'function') {
    props.onCarouselIsEmpty();
  }
  if (props.onDataReceived && typeof props.onDataReceived === 'function') {
    props.onDataReceived(data);
  }
  const enhancedItems = [...prevItemsFromProps, ...itemsFromRecos].map((item, index) => {
    const isCriticalImage = index + 1 <= itemImagesToPreload;
    return _objectSpread(_objectSpread(_objectSpread({}, mapPropsToQuery$1({
      componentProps: props,
      paramsToMap: forwardedPropsToItem
    })), {}, {
      track_info: track
    }, item), {}, {
      preload: isCriticalImage,
      // this comes after the spread because it depends on carousel lazy status (we want to override the backend preload)
      fetchPriority: isCriticalImage && fetchPriority || undefined // nordic needs string/undefined -no bool-
    });
  });
  const items = multipleRows ? divideByGroups$1(enhancedItems, multipleRows) : enhancedItems;
  return {
    title,
    titleWithIcons,
    titleTag,
    subtitle,
    footer,
    items,
    track,
    href,
    message,
    carouselType,
    viewMoreAction,
    key: carouselKey,
    classnameFromResponse,
    polycardContext
  };
};
const fetchRecommendations = (params, headers, isPolycard) => {
  const path = isPolycard ? API_PATH_POLYCARD : API_PATH;
  const header = isPolycard ? polycardHeaders : defaultHeaders;
  try {
    const requestHeaders = _objectSpread(_objectSpread({}, header), headers);
    const isValid = validateParams(_objectSpread({
      user_id: params.userId
    }, params));
    if (!isValid) {
      return Promise.reject(Error('Some required fields are missing.'));
    }
    return canUseWebp.then(webp => {
      requestHeaders['x-image-webp'] = webp;
      return restclient$1.get(path, {
        params,
        headers: requestHeaders,
        baseURL: getHostname(params)
      }).catch( /* istanbul ignore next */() => {
        // do nothing
      });
    }).catch( /* istanbul ignore next */() => {
      // do nothing
    });
  } catch (e) {
    /* istanbul ignore next */
    return Promise.reject(e);
  }
};
const getLab = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    if (props.env) {
      return props.env;
    }
    if (document && document.cookie) {
      const meliLabCookie = document.cookie.split(';').find(s => s.split('=')[0].trim() === 'meliLab');
      if (meliLabCookie) {
        const currentLab = meliLabCookie.split('=')[1].trim();
        const hardcodedLabs = {
          recosreact: 'test0',
          recos: 'test',
          release: 'testrelease'
        };
        if (currentLab in hardcodedLabs) {
          // eslint-disable-next-line security/detect-object-injection
          return hardcodedLabs[currentLab];
        }
        if (currentLab.match(/recos-([0-9]*)/)) {
          return "test".concat(currentLab.split('-')[1]);
        }
      }
    }
  } catch (error) {
    if (console) {
      // eslint-disable-next-line no-console
      console.info('Recommendations - Cannot get lab info.', error);
    }
  }
  return undefined;
};
const addToCart = (endpoint, itemInfo) => {
  var _window;
  const restConfig = {
    baseURL: ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin) || '',
    maxRedirects: 0,
    method: 'post',
    responseType: 'json',
    sendCSRFToken: true,
    timeout: 25000
  };
  return frontendRestclient(restConfig).post(endpoint, {
    headers: {
      'Content-Type': 'application/json'
    },
    data: itemInfo
  });
};
var recommendations = /*#__PURE__*/Object.freeze({
  __proto__: null,
  API_PATH: API_PATH,
  FALLBACK_URL: FALLBACK_URL,
  addToCart: addToCart,
  fetchRecommendations: fetchRecommendations,
  formatApiResponse: formatApiResponse,
  getHostname: getHostname,
  getLab: getLab
});
const idGenerator = _ref => {
  let {
    client,
    categoryId,
    productId,
    itemId,
    itemIds,
    variationId
  } = _ref;
  return "".concat(client, "_").concat(categoryId, "_").concat(productId, "_").concat(itemId, "_").concat(itemIds, "_").concat(variationId);
};
const forwardedPropsToRestClient = ['client', 'limit', 'host_rewrite', 'site_platform', 'web_device', 'platform', 'page', 'positions', 'machi_boost', 'vid', 'purchased_category', 'q', 'pads_vip_case', 'min_recomms', 'RECOMMENDED.force_categories', 'RECOMMENDED.cnt', 'ignore_min_reco_size', 'webView', 'picture_id', 'bbw_ads', 'include_only_flex'];
const hidePreload = _ref2 => {
  let {
    preloadId,
    onCarouselLoaded
  } = _ref2;
  if (preloadId) {
    document.getElementById(preloadId).remove();
  }
  if (onCarouselLoaded && typeof onCarouselLoaded === 'function') {
    onCarouselLoaded();
  }
};
const useRecommendations = props => {
  const [alreadyFetched, setAlreadyFetched] = react.useState(false);
  const [fetchedRecommendations, setFetchedRecommendations] = react.useState(null);
  const [prevId, setPrevId] = react.useState(idGenerator(props));
  const {
    onCarouselIsEmpty,
    apiresponse,
    client,
    variationId,
    siteId,
    categoryId,
    itemId,
    itemIds,
    productId,
    d2Id,
    userId,
    itemsIds,
    platformId,
    platform,
    zipCode,
    zoneModels,
    web_device: webDevice,
    stateId,
    encodedFilters,
    isPolycard,
    onDataReceived
  } = props;
  if (apiresponse) {
    if (!alreadyFetched) {
      const formattedRecommendations = formatApiResponse(apiresponse, props, idGenerator(props));
      setFetchedRecommendations(formattedRecommendations);
      setAlreadyFetched(true);
      hidePreload(props); // en casos de SSR, no deberíamos tener preload, pero dejamos esto para cumplir el contrato
      return formattedRecommendations;
    }
    return fetchedRecommendations;
  }
  react.useEffect(() => {
    if (alreadyFetched && prevId === idGenerator(props)) {
      return;
    }
    setAlreadyFetched(true);
    setPrevId(idGenerator(props));
    const query = _objectSpread(_objectSpread({}, mapPropsToQuery$1({
      componentProps: props,
      paramsToMap: forwardedPropsToRestClient
    })), {}, {
      site_id: siteId,
      category_id: categoryId,
      item_id: itemId,
      item_ids: itemIds,
      product_id: productId,
      variation_id: variationId,
      d2_id: d2Id,
      items_ids: itemsIds,
      user_id: userId,
      platform_id: platformId,
      env: getLab(props),
      'user-zip-code': zipCode,
      'user-buyer-zone': zoneModels,
      'user-platform': platform || webDevice,
      'user-state-id': stateId,
      'user-encoded-filters': encodedFilters
    });
    fetchRecommendations(query, null, isPolycard).then(data => {
      setFetchedRecommendations(formatApiResponse(data.data, props, idGenerator(props)));
      hidePreload(props);
    }).catch(() => {
      hidePreload(props);
      // onCarouselIsEmpty es evaluado en formatApiResponse, pero como eso no ocurrió, lo mandamos manualmente acá.
      if (onCarouselIsEmpty && typeof onCarouselIsEmpty === 'function') {
        onCarouselIsEmpty();
      }
      if (onDataReceived && typeof onDataReceived === 'function') {
        onDataReceived(null);
      }
      // este set lo generamos para obligar a un re-render.
      setFetchedRecommendations(undefined);
    });
  }, [alreadyFetched, prevId, siteId, categoryId, itemId, itemIds, productId, d2Id, props, onCarouselIsEmpty, client, variationId]); // eslint-disable-line react-hooks/exhaustive-deps, max-len

  return fetchedRecommendations;
};
var useRecommendations$1 = useRecommendations;

// este restclient no es de interacción con el usuario. Se sube el timeout.
const defaultClientConfig = {
  baseURL: 'https://www.mercadolibre.com.ar/',
  timeout: 30000,
  sendCSRFToken: false
};
const restclient = frontendRestclient(defaultClientConfig);
const trackAdvertisingPixel = trackUrl => {
  if (!trackUrl) {
    // eslint-disable-next-line no-console
    console.warn('Track Ads missing');
    return Promise.reject(Error('Track Ads missing'));
  }
  try {
    // eslint-disable-next-line no-unused-vars
    return restclient.get(trackUrl).then(response => {
      // do nothing.
      // eslint-disable-next-line no-console
    }).catch( /* istanbul ignore next */e => console.warn('Track Ads failed', e));
  } catch (e) {
    /* istanbul ignore next */
    // eslint-disable-next-line no-console
    console.warn('Track Ads failed', e);
    /* istanbul ignore next */
    return Promise.reject(e);
  }
};
var trackAdvertisingPixel$1 = trackAdvertisingPixel;

/* eslint-disable no-undef */
const RECOMMENDATIONS_COMPARATOR_PATH = '/recommendations';
const RECOMMENDATIONS_COMPARATOR_STREAM = 'recommendations';
const COMBOS_PATH = '/combos';
class TrackService {
  static send(recommendationsTrack) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'print';
    let privateStream = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let overridePath = arguments.length > 3 ? arguments[3] : undefined;
    let useBeacon = arguments.length > 4 ? arguments[4] : undefined;
    // eslint-disable-next-line camelcase
    const {
      event_data: eventData,
      experiments,
      experiment,
      advertising_info
    } = recommendationsTrack;
    const track = {};
    const melidataTrackType = type === 'print' ? 'createEventTrack' : 'createViewTrack';
    if (typeof melidata === 'function') {
      melidata(melidataTrackType, track);
      if (overridePath) {
        melidata('withPath', overridePath, track);
      } else if (privateStream) {
        melidata('withPath', "".concat(RECOMMENDATIONS_COMPARATOR_PATH, "/").concat(type), track);
      } else {
        melidata('withPath', "".concat(RECOMMENDATIONS_COMPARATOR_PATH), track);
      }
      melidata('withData', eventData, track);
      if (privateStream) {
        melidata('withStream', RECOMMENDATIONS_COMPARATOR_STREAM, track);
      }
      if (experiment || experiments) {
        melidata('withExperiments', experiment || experiments, track);
      }
      if (useBeacon) {
        track.useBeacon = true;
      }
      melidata('sendTrack', track);
      // eslint-disable-next-line camelcase
      if (type === 'print' && privateStream && advertising_info && advertising_info.print_url) {
        // eslint-disable-next-line camelcase
        trackAdvertisingPixel$1(advertising_info.print_url);
      }
    }
  }
  static print(recommendationsTrack) {
    TrackService.send(recommendationsTrack, 'print', true);
  }
  static view(recommendationsTrack) {
    TrackService.send(recommendationsTrack, 'view', true);
  }
  static event(recommendationsTrack) {
    TrackService.send(recommendationsTrack, 'event', true);
  }
  static clickMore(recommendationsTrack) {
    TrackService.send(recommendationsTrack, 'event', true, "".concat(RECOMMENDATIONS_COMPARATOR_PATH, "/see_more"), false);
  }
  static requestIgnored(client) {
    const recoTrack = {
      event_data: {
        recommendations: {
          client,
          has_errors: true,
          hidden_by_client: true,
          track_info: {
            has_recommendations: false,
            empty_result_cause: 'SCROLLED_INTO_VIEWPORT'
          }
        }
      }
    };
    TrackService.send(recoTrack, 'event', true, "".concat(RECOMMENDATIONS_COMPARATOR_PATH), false);
  }
  static addToCartCombo(recommendationsTrack) {
    TrackService.send(recommendationsTrack, 'print', true, "".concat(COMBOS_PATH, "/add_to_cart"), true);
  }
  static checkedCombo(recommendationsTrack) {
    TrackService.send(recommendationsTrack, 'print', true, "".concat(COMBOS_PATH, "/checked"), true);
  }
  static viewCombos(recommendationsTrack) {
    TrackService.send(recommendationsTrack, 'view', true, "".concat(COMBOS_PATH, "/view_combos"), true);
  }
}
var TrackService$1 = TrackService;

// React
const useTrackOnPrint = () => {
  const whenIdle = global.requestIdleCallback ? requestIdleCallback : setTimeout;

  // Tracking Callback
  const trackOnPrint = react.useCallback(trackData => {
    whenIdle(() => {
      TrackService$1.print(trackData);
    });
  }, [whenIdle]);
  return {
    trackOnPrint
  };
};
var useTrackOnPrint$1 = useTrackOnPrint;
const useTrackOnView = function () {
  let {
    componentRef = null,
    trackingFunction = null,
    trackData = null,
    client,
    trackedOnViewClients = [],
    setTrackedOnViewClients = null,
    shouldTrackOnView = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Set the tracked state for the client
  const alreadyTracked = Array.isArray(trackedOnViewClients) ? trackedOnViewClients.includes(client) : trackedOnViewClients;

  // Gets the IO status for the ref
  const {
    isOnViewport
  } = useIntersectionObserver$1({
    externalRef: componentRef,
    rootMargin: '0px',
    threshold: 0.1,
    once: true,
    startOff: alreadyTracked
  });
  const serviceToUse = trackingFunction || TrackService$1.view;
  const whenIdle = global.requestIdleCallback ? requestIdleCallback : setTimeout;

  // Track if is untracked and on the viewport
  // disable lint - depende solo de estar intersectando y de que sea otro client
  react.useEffect(() => {
    if (!global.IntersectionObserver) return;
    whenIdle(() => {
      if (!alreadyTracked && isOnViewport && shouldTrackOnView) {
        serviceToUse(trackData);
        if (Array.isArray(trackedOnViewClients)) {
          setTrackedOnViewClients([...trackedOnViewClients, client]);
        } else {
          setTrackedOnViewClients(true);
        }
      }
    });
  }, [isOnViewport, client, trackData, shouldTrackOnView]); // eslint-disable-line react-hooks/exhaustive-deps
};
var useTrackOnView$1 = useTrackOnView;
const useTrackRecommendations = function () {
  let {
    carouselContainerRef,
    trackData,
    shouldTrackOnView,
    trackingFunction = null
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Set the tracked clients + Get a callback for PRINT tracking
  const [trackedOnViewClients, setTrackedOnViewClients] = react.useState(false);
  const [trackedOnPrintClients, setTrackedOnPrintClients] = react.useState(false);
  const {
    trackOnPrint
  } = useTrackOnPrint$1();

  // Reset the tracked clients + try to track the print of the recommendations
  // Effect triggers when trackData changes (new recos = new track)
  // Eslint disable - Depende solo de trackData
  react.useEffect(() => {
    setTrackedOnPrintClients(false);
    setTrackedOnViewClients(false);
    if (trackData) {
      if (!trackedOnPrintClients) {
        trackOnPrint(trackData);
        setTrackedOnPrintClients(true);
      }
    }
  }, [trackData]); // eslint-disable-line react-hooks/exhaustive-deps

  // TRACK ON VIEW => Automatic track when is on the viewport
  useTrackOnView$1({
    componentRef: carouselContainerRef,
    trackData,
    trackingFunction,
    trackedOnViewClients,
    setTrackedOnViewClients,
    shouldTrackOnView
  });
  return {
    trackedOnViewClients,
    setTrackedOnViewClients,
    trackedOnPrintClients,
    setTrackedOnPrintClients
  };
};
var useTrackRecommendations$1 = useTrackRecommendations;
const namespaceRecommendations = 'ui-recommendations';
const _excluded$1 = ["lazy", "customRootMargin", "preload", "criticalImages", "slidesPerView", "hasDynamicSlidesPerView", "dynamicSlidesConfig", "contextProps", "cardType", "isPolycard", "Card", "deviceType"];
const polycardTemplate = polyProps => /*#__PURE__*/_jsx(card.Card, {
  polycard: _objectSpread({}, polyProps),
  styles: polyProps.styles
});
const withCarouselContainer = WrappedCarousel => {
  const CarouselContainer = _ref => {
    var _recommendationsProps, _recommendationsProps2;
    let {
        lazy = true,
        customRootMargin,
        preload,
        criticalImages,
        slidesPerView,
        hasDynamicSlidesPerView,
        dynamicSlidesConfig,
        contextProps,
        cardType,
        isPolycard = false,
        Card: legacyCard,
        deviceType
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded$1);
    // ShouldRender status - Set and update
    const [shouldRender, setShouldRender] = react.useState(!lazy);
    const carouselContainerRef = react.useRef();
    const {
      isOnViewport
    } = useIntersectionObserver$1({
      externalRef: carouselContainerRef,
      rootMargin: customRootMargin || '420px',
      threshold: 0,
      once: true,
      startOff: false,
      fallbackValue: true
    });
    react.useEffect(() => {
      if (isOnViewport) {
        setShouldRender(true);
      }
    }, [isOnViewport]);

    // Preload nordic/image setup
    let itemImagesToPreload;
    if (!lazy && preload) {
      itemImagesToPreload = criticalImages || slidesPerView || 4; // 4 is the default items for list/grid
    }

    // Get new props for the carousel aka recommendations (with ssr or service)
    const recommendationsProps = useRecommendations$1(_objectSpread(_objectSpread({}, props), {}, {
      itemImagesToPreload,
      isPolycard
    }));

    // Tracks when the recommendation is printed and is on the viewport
    useTrackRecommendations$1({
      carouselContainerRef,
      trackData: recommendationsProps === null || recommendationsProps === void 0 ? void 0 : recommendationsProps.track,
      shouldTrackOnView: recommendationsProps && recommendationsProps.items && recommendationsProps.items.length > 0
    });

    // Handle the dynamic -slidePerView- status
    const [dynamicSlidesPerView, setDynamicSlidesPerView] = react.useState(null);
    const SLIDE_WIDTH = 222;
    const SLIDE_MARGIN = 12;
    const SLIDE_TOTAL = 5; // Default = Carousel Snapped atf
    const SLIDE_AND_MARGIN_WIDTH = (dynamicSlidesConfig === null || dynamicSlidesConfig === void 0 ? void 0 : dynamicSlidesConfig.slideAndMargin) || SLIDE_WIDTH + SLIDE_MARGIN;
    const LAST_MARGIN_RIGHT = (dynamicSlidesConfig === null || dynamicSlidesConfig === void 0 ? void 0 : dynamicSlidesConfig.lastMarginRight) || SLIDE_MARGIN;
    const MAX_VISIBLE_SLIDES = (dynamicSlidesConfig === null || dynamicSlidesConfig === void 0 ? void 0 : dynamicSlidesConfig.maxVisibleSlides) || SLIDE_TOTAL;
    react.useEffect(() => {
      if (hasDynamicSlidesPerView && carouselContainerRef.current) {
        const wrapperWidth = carouselContainerRef.current.getBoundingClientRect().width;
        const slidesInWrapper = Math.trunc((wrapperWidth + LAST_MARGIN_RIGHT) / SLIDE_AND_MARGIN_WIDTH);
        if (slidesInWrapper < MAX_VISIBLE_SLIDES) setDynamicSlidesPerView(slidesInWrapper);
        if (slidesInWrapper >= MAX_VISIBLE_SLIDES) setDynamicSlidesPerView(MAX_VISIBLE_SLIDES);
      }
    }, [hasDynamicSlidesPerView, SLIDE_AND_MARGIN_WIDTH, LAST_MARGIN_RIGHT, MAX_VISIBLE_SLIDES]);

    // Fallbacks and retro-compatibility for Polycard Money Amount Separators
    const separators = {
      thousandSeparator: (contextProps === null || contextProps === void 0 ? void 0 : contextProps.thousandSeparator) || (recommendationsProps === null || recommendationsProps === void 0 || (_recommendationsProps = recommendationsProps.polycardContext) === null || _recommendationsProps === void 0 ? void 0 : _recommendationsProps.thousand_separator),
      decimalSeparator: (contextProps === null || contextProps === void 0 ? void 0 : contextProps.decimalSeparator) || (recommendationsProps === null || recommendationsProps === void 0 || (_recommendationsProps2 = recommendationsProps.polycardContext) === null || _recommendationsProps2 === void 0 ? void 0 : _recommendationsProps2.decimal_separator)
    };
    // Fallback and retro-compatibility for Polycard card Type
    const polyType = cardType || (contextProps === null || contextProps === void 0 ? void 0 : contextProps.type);

    // Should render Polycard or Legacy Card
    const isPolycardContextNotEmpty = (recommendationsProps === null || recommendationsProps === void 0 ? void 0 : recommendationsProps.polycardContext) && Object.keys(recommendationsProps.polycardContext).length > 0;
    const renderPolycard = !!(isPolycardContextNotEmpty && separators.thousandSeparator && separators.decimalSeparator);
    const CardToUse = renderPolycard ? polycardTemplate : legacyCard;
    return /*#__PURE__*/jsxRuntime.jsxs("section", {
      ref: carouselContainerRef,
      className: "".concat(namespaceRecommendations, "-carousel-wrapper-ref"),
      children: [/*#__PURE__*/_jsx(frontendImage.Image, {
        src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        alt: "",
        lazyload: "on",
        className: "".concat(namespaceRecommendations, "-carousel-container-img")
      }), !renderPolycard && shouldRender && recommendationsProps && /*#__PURE__*/jsxRuntime.jsx(WrappedCarousel, _objectSpread(_objectSpread({}, props), {}, {
        slidesPerView: dynamicSlidesPerView || slidesPerView,
        Card: CardToUse
      }, recommendationsProps)), renderPolycard && shouldRender && /*#__PURE__*/jsxRuntime.jsx(card.PolycardContext, _objectSpread(_objectSpread({
        contextValue: _objectSpread(_objectSpread({}, recommendationsProps === null || recommendationsProps === void 0 ? void 0 : recommendationsProps.polycardContext), polyType && {
          type: polyType
        })
      }, separators), {}, {
        deviceType: deviceType,
        children: /*#__PURE__*/jsxRuntime.jsx(WrappedCarousel, _objectSpread(_objectSpread({}, props), {}, {
          cardType: polyType,
          slidesPerView: dynamicSlidesPerView || slidesPerView,
          isPolycard: true,
          Card: CardToUse
        }, recommendationsProps))
      }))]
    });
  };
  return CarouselContainer;
};
var withCarouselContainer$1 = withCarouselContainer;
const generatorClassKey = (type, obj, className) => {
  const DEFAULT = false;
  const namespace = "".concat(namespaceRecommendations, "-").concat(type);
  // eslint-disable-next-line security/detect-object-injection
  const typeName = typeof obj === 'string' ? obj : obj && obj[type] || DEFAULT;
  return classnames({
    ["".concat(namespace, "--").concat(typeName)]: typeName
  }, className);
};

// eslint-disable-next-line camelcase
const applyClasses = _ref => {
  let {
    size,
    family,
    color,
    bg_color,
    className
  } = _ref;
  return (
    // eslint-disable-next-line implicit-arrow-linebreak
    generatorClassKey('background-color', bg_color, generatorClassKey('font-color', color, generatorClassKey('font-size', size, generatorClassKey('font-family', family, className))))
  );
};
var applyclasses = applyClasses;
const _excluded = ["as", "withDangerous", "text", "color", "bg_color", "font_family", "font_size", "className", "accessibilityText", "children"];
const createMarkup = text => ({
  __html: text
});
const allowedForwardedProps = ['href', 'target', 'id', 'onClick', 'data-testid'];
const filterForwardProps = function () {
  let forwardProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(forwardProps).reduce((acc, _ref) => {
    let [name, value] = _ref;
    if (allowedForwardedProps.includes(name)) {
      // eslint-disable-next-line security/detect-object-injection
      acc[name] = value;
    }
    return acc;
  }, {});
};

// Map from BE props to FE naming
const StyledLabel = _ref2 => {
  let {
      as,
      withDangerous,
      text,
      color,
      // eslint-disable-next-line camelcase
      bg_color,
      // eslint-disable-next-line camelcase
      font_family,
      // eslint-disable-next-line camelcase
      font_size,
      className,
      accessibilityText,
      children
    } = _ref2,
    forwardProps = _objectWithoutProperties(_ref2, _excluded);
  const classes = applyclasses({
    // eslint-disable-next-line camelcase
    size: font_size,
    // eslint-disable-next-line camelcase
    family: font_family,
    color,
    // eslint-disable-next-line camelcase
    bg_color,
    className
  });
  const Element = as;
  const filteredForwardedProps = filterForwardProps(forwardProps);
  if (withDangerous) {
    return /*#__PURE__*/jsxRuntime.jsx(Element, _objectSpread(_objectSpread({
      className: classes
    }, filteredForwardedProps), {}, {
      dangerouslySetInnerHTML: createMarkup(text)
    }));
  }
  return /*#__PURE__*/jsxRuntime.jsxs(Element, _objectSpread(_objectSpread({
    className: classes
  }, filteredForwardedProps), {}, {
    children: [text, accessibilityText && /*#__PURE__*/_jsx("span", {
      className: "ui-home--hide"
    }, void 0, accessibilityText), children]
  }));
};
StyledLabel.defaultProps = {
  as: 'p',
  alignment: null,
  withDangerous: false,
  bg_color: null,
  className: null,
  text: null,
  color: null,
  font_family: 'REGULAR',
  font_size: null,
  accessibilityText: null,
  children: null,
  margin: null
};
var StyledLabel$1 = StyledLabel;
const INTERPOLATION_REGEXP = /{([\s\S]+?)}/g;
const RECOMMENDATIONS_REGEXP = /^recommendations-/i;
const prefixer = icon => {
  let replacement;
  if (typeof icon === 'string') {
    replacement = RECOMMENDATIONS_REGEXP.test(icon) ? icon : "recommendations-".concat(icon);
  }
  if (isObject(icon) && typeof icon.id === 'string') {
    replacement = _objectSpread(_objectSpread({}, icon), {}, {
      id: RECOMMENDATIONS_REGEXP.test(icon.id) ? icon.id : "recommendations-".concat(icon.id)
    });
  }
  return replacement;
};
const interpolator = (text, values, IconFactory) => {
  if (isEmpty(values)) {
    return text;
  }
  const result = text.split(INTERPOLATION_REGEXP);

  /* eslint-disable security/detect-object-injection */
  for (let index = 0; index < result.length; index += 1) {
    const key = result[index];
    if (values && values[key]) {
      const value = values[key];
      switch (value.type) {
        /* istanbul ignore next */
        case 'money':
          {
            const {
              amount,
              centsType,
              size
            } = value.price;
            const moneyAmountProps = {
              className: "".concat(namespaceRecommendations, "-card__price"),
              value: {
                fraction: amount.fraction.toString(),
                cents: amount.cents
              },
              symbol: amount.symbol,
              currencyId: amount.currency_id,
              size,
              centsType
            };
            result[index] = /*#__PURE__*/jsxRuntime.jsx(MoneyAmount, _objectSpread({}, moneyAmountProps));
          }
          break;
        case 'icon':
          {
            const prefixedIcon = prefixer(value);
            result[index] = IconFactory(prefixedIcon, "".concat(namespaceRecommendations, "-icon ").concat(namespaceRecommendations, "-icon-").concat(key));
          }
          break;
        default:
          result[index] = /*#__PURE__*/jsxRuntime.jsx(StyledLabel$1, _objectSpread({
            as: "span",
            text: text
          }, value));
          break;
      }
    }
  }
  return result;
};

/* eslint-enable security/detect-object-injection */

var interpolator$1 = interpolator;
const RecommendationsTitle = _ref => {
  let {
    title,
    titleWithIcons,
    href,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceRecommendations, "-title");
  let enhancedTitle = title;
  if (titleWithIcons) {
    // agregamos type porque los iconos pueden venir sin type, o incluso ser strings
    Object.values(titleWithIcons.values).forEach(val => {
      val.type = 'icon';
    });
    enhancedTitle = interpolator$1(titleWithIcons.text, titleWithIcons.values, IconFactory);
  } else if (typeof title === 'string') {
    enhancedTitle = title;
  } else if (typeof title === 'object') {
    enhancedTitle = interpolator$1(title.text, title.values, IconFactory);
  }
  if (href) {
    return /*#__PURE__*/_jsx("div", {
      className: namespace
    }, void 0, /*#__PURE__*/_jsx("a", {
      href: href,
      className: "".concat(namespace, "-link")
    }, void 0, enhancedTitle));
  }
  return /*#__PURE__*/_jsx("div", {
    className: namespace
  }, void 0, /*#__PURE__*/_jsx("h2", {
    className: "".concat(namespace, "-link")
  }, void 0, enhancedTitle));
};
var RecommendationsTitle$1 = RecommendationsTitle;
const namespace = "".concat(namespaceRecommendations, "-title-tag");
const RecommendationsTitleTag = _ref => {
  let {
    text,
    values,
    styles,
    IconFactory,
    onTitleTagClick
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: namespace
  }, void 0, /*#__PURE__*/jsxRuntime.jsx(StyledLabel$1, _objectSpread({
    as: onTitleTagClick ? 'button' : 'p',
    text: interpolator$1(text, values, IconFactory),
    className: "".concat(namespace, "__text"),
    onTitleTagClick: onTitleTagClick
  }, styles)));
};
var RecommendationsTitleTag$1 = RecommendationsTitleTag;
const RecommendationsSubtitle = _ref => {
  let {
    text,
    url,
    advertisingLabel,
    accessibilityText
  } = _ref;
  const namespace = "".concat(namespaceRecommendations, "-subtitle");
  return /*#__PURE__*/_jsx("div", {
    className: namespace
  }, void 0, /*#__PURE__*/_jsx("a", {
    href: url,
    rel: "nofollow".concat(advertisingLabel !== undefined ? ', sponsored' : ''),
    className: "".concat(namespace, "-link")
  }, void 0, text, " ", accessibilityText && /*#__PURE__*/_jsx("span", {
    className: "andes-visually-hidden"
  }, void 0, accessibilityText)));
};
var RecommendationsSubtitle$1 = RecommendationsSubtitle;
const RecommendationsSideButton = _ref => {
  let {
    id,
    target,
    label,
    buttonSize
  } = _ref;
  const namespace = "".concat(namespaceRecommendations, "-side-button");
  return /*#__PURE__*/_jsx("div", {
    className: namespace
  }, void 0, /*#__PURE__*/_jsx(button.Button, {
    id: id,
    hierarchy: "quiet",
    size: buttonSize,
    href: target,
    className: "andes-button--secondary"
  }, void 0, label));
};
var RecommendationsSideButton$1 = RecommendationsSideButton;
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RecommendationsFooter = _ref => {
  let {
    footerText,
    href,
    withChevron,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceRecommendations, "-footer");
  return /*#__PURE__*/_jsx("a", {
    className: "".concat(namespace, "__link"),
    rel: "nofollow",
    href: href
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__wrapper")
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__text")
  }, void 0, footerText), withChevron && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__chevron")
  }, void 0, IconFactory(RECOMMENDATIONS_CHEVRON, "".concat(namespace, "-icon")))));
};
var RecommendationsFooter$1 = RecommendationsFooter;
function priceSizeByDigits(price, priceSizeOverride) {
  const digits = price.fraction && price.symbol ? price.fraction.length + price.symbol.length : 0;
  let priceSize = 24;
  let discountSize = 14;
  if (digits === 10) {
    priceSize = 23;
    discountSize = 12;
  } else if (digits === 11) {
    priceSize = 22;
    discountSize = 12;
  } else if (digits >= 12) {
    priceSize = 20;
    discountSize = 12;
  }
  return {
    priceSize: (priceSizeOverride === null || priceSizeOverride === void 0 ? void 0 : priceSizeOverride.price) || priceSize,
    discountSize: (priceSizeOverride === null || priceSizeOverride === void 0 ? void 0 : priceSizeOverride.discount) || discountSize
  };
}
const getFormattedIntFraction = (price, thousandSeparator) => {
  const rawFraction = Math.floor(price.toFixed(2)).toString();
  return rawFraction.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, n => "".concat(n).concat(thousandSeparator));
};
const getFormattedDecimalFraction = price => {
  const fixedStr = price.toFixed(2);
  return fixedStr.split('.')[1] === '00' ? '' : fixedStr.split('.')[1];
};
exports.RecommendationsFooter = RecommendationsFooter$1;
exports.RecommendationsSideButton = RecommendationsSideButton$1;
exports.RecommendationsSubtitle = RecommendationsSubtitle$1;
exports.RecommendationsTitle = RecommendationsTitle$1;
exports.RecommendationsTitleTag = RecommendationsTitleTag$1;
exports.TrackService = TrackService$1;
exports.divideByGroups = divideByGroups$1;
exports.getFormattedDecimalFraction = getFormattedDecimalFraction;
exports.getFormattedIntFraction = getFormattedIntFraction;
exports.interpolator = interpolator$1;
exports.mapPropsToQuery = mapPropsToQuery$1;
exports.priceSizeByDigits = priceSizeByDigits;
exports.recommendationsService = recommendations;
exports.useIntersectionObserver = useIntersectionObserver$1;
exports.useRecommendations = useRecommendations$1;
exports.useTrackOnPrint = useTrackOnPrint$1;
exports.useTrackOnView = useTrackOnView$1;
exports.useTrackRecommendations = useTrackRecommendations$1;
exports.withCarouselContainer = withCarouselContainer$1;
